import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { voiceDependentAfterLine } from '../../helpers/voiceActionDisplay';
import type { VoiceAction } from '../../types/voice';

interface ActionCardDependentLineProps {
  dependentActions?: VoiceAction[];
}

export const ActionCardDependentLine: FC<ActionCardDependentLineProps> = ({ dependentActions }) => {
  const line = voiceDependentAfterLine(dependentActions);
  if (!line) return null;

  return (
    <Box sx={{ minWidth: 0, maxWidth: '100%', mb: 0.25 }}>
      <Text
        style={{
          fontSize: 10,
          color: 'var(--tg-theme-button-color)',
          fontWeight: 600,
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {line}
      </Text>
    </Box>
  );
};
